import { ActionIcon, Menu } from '@mantine/core';
import { BsThreeDots } from 'react-icons/bs';
import { FiCheckCircle, FiEdit, FiTrash2 } from 'react-icons/fi';

interface JobActionsMenuProps {
  completeJobHref: string;
  editQuestionsHref: string;
  onDeleteJob: () => void;
}

// For mobile layout
export default function JobActionsMenu({
  completeJobHref,
  editQuestionsHref,
  onDeleteJob,
}: JobActionsMenuProps) {
  return (
    <Menu position="bottom-end" shadow="md" withinPortal>
      <Menu.Target>
        <ActionIcon variant="subtle" color="dark" aria-label="Job actions">
          <BsThreeDots size={20} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          component="a"
          href={completeJobHref}
          leftSection={<FiCheckCircle size={18} />}
        >
          Edit job
        </Menu.Item>
        <Menu.Item
          component="a"
          href={editQuestionsHref}
          leftSection={<FiEdit size={18} />}
        >
          Edit questions
        </Menu.Item>
        <Menu.Item leftSection={<FiTrash2 size={18} />} onClick={onDeleteJob}>
          Delete job
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
